module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-sm-4\"> Select a Zone: <div class=\"dropdown zone form-group\"> <a href=\"#\" class=\"dropdown-toggle btn btn-default btn-block\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"> Zone ")
    ; __append(escapeFn( locals.selectedZone ))
    ; __append(" <small class=\"text-muted glyphicon glyphicon-menu-down\"></small> </a> <ul class=\"dropdown-menu\"> ")
    ;  _.forEach(locals.zones, function(zone) { 
    ; __append(" <li><a ")
    ; __append(escapeFn( (zone == locals.selectedZone ? 'class="active"' : "") ))
    ; __append(" data-zone=\"")
    ; __append(escapeFn( zone ))
    ; __append("\">Zone ")
    ; __append(escapeFn( zone ))
    ; __append("</a></li> ")
    ;  }); 
    ; __append(" </ul> </div> </div> <div class=\"col-sm-4\"> Select a Predefined Package: <div class=\"dropdown type form-group\"> <a href=\"#\" class=\"dropdown-toggle btn btn-default btn-block\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\"> ")
    ; __append(escapeFn( locals.selectedType ))
    ; __append(" <small class=\"text-muted glyphicon glyphicon-menu-down\"></small> </a> <ul class=\"dropdown-menu\"> ")
    ;  _.forEach(locals.types, function(type) { 
    ; __append(" <li><a ")
    ; __append(escapeFn( (type == locals.selectedType ? 'class="active"' : "") ))
    ; __append(" data-type=\"")
    ; __append(escapeFn( type ))
    ; __append("\">")
    ; __append(escapeFn( type ))
    ; __append("</a></li> ")
    ;  }); 
    ; __append(" </ul> </div> </div> </div> <h3>Rate Chart</h3> <table class=\"table table-striped table-bordered table-condensed\"> <thead> <tr> <th> Weight</th> ")
    ;  _.forEach(locals.subtypes, function(subtype) { 
    ; __append(" <th>")
    ; __append(escapeFn( subtype ))
    ; __append("</th> ")
    ;  }); 
    ; __append(" </tr> </thead> <tbody> ")
    ;  for (var i = 0; i < locals.weights.length; i++) { 
    ; __append(" <tr> <td>")
    ; __append(escapeFn( locals.weights[i] ))
    ; __append("</td> ")
    ;  _.forEach(locals.subtypes, function(subtype) { 
    ; __append(" <td>")
    ; __append(escapeFn( locals.data[subtype][i] ))
    ; __append("</td> ")
    ;  }); 
    ; __append(" </tr> ")
    ;  } 
    ; __append(" </tbody> </table> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/usps_rate_chart.ejs
// module id = 879
// module chunks = 1